// Tabs rendered by Header.tsx and the routes each one owns. Authorization is
// per tab, not per route: the PSC tab also owns the ambulance/details/regis
// dashboards and Management owns every management section, and none of those
// sub-routes carry a cm_program row of their own to be granted individually.
export interface HeaderTab {
  /** Stable key for access checks and the healthcare relabel in Header.tsx. */
  name: string;
  /** cm_language tag the tab is rendered with. */
  tag: string;
  /** Dashboard url the backend grants for this tab (a DASHBOARD child program). */
  grant: string;
  /** Every protected route the tab owns; these mirror the routes in main.tsx. */
  paths: string[];
}

export const DASHBOARD_TABS: HeaderTab[] = [
  {
    name: 'Smart City',
    tag: 'cmn>nav>smart city',
    grant: '/dashboard/smartCity-dashboard',
    paths: ['/dashboard/smartCity-dashboard'],
  },
  {
    name: 'Traffic',
    tag: 'cmn>nav>traffic',
    grant: '/dashboard/traffic-dashboard',
    paths: ['/dashboard/traffic-dashboard', '/dashboard/event-dashboard'],
  },
  {
    name: 'PSC',
    tag: 'cmn>nav>PSC',
    grant: '/dashboard/psc-dashboard',
    paths: [
      '/dashboard/psc-dashboard',
      '/dashboard/ambulance-dashboard',
      '/dashboard/details-dashboard',
      '/dashboard/regis-dashboard',
    ],
  },
  {
    name: 'CCTV',
    tag: 'cmn>nav>CCTV',
    grant: '/dashboard/cctv-dashboard',
    paths: ['/dashboard/cctv-dashboard', '/dashboard/cctvDetail-dashboard'],
  },
];

// Sections behind the Management tab, in the order Sidebar.tsx lays them out.
// Each one is granted through the child programs sharing its prefix, so a
// section opens exactly when one of those children is authorized.
export const MANAGEMENT_SECTIONS = [
  '/system-management',
  '/asset-management',
  '/report-management',
  '/site-management',
  '/statistic',
  '/scenario',
  '/log',
  '/sensor-management',
];
